import React, { Component, ReactNode } from 'react';

import { UserVisibleError } from '../UserVisibleError';
import { ErrorPage } from './pages/ErrorPage';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    return error ? (
      <ErrorPage message={error instanceof UserVisibleError ? error.message : 'Internal error.'} />
    ) : (
      this.props.children
    );
  }
}
